import React from 'react';
import { motion } from 'framer-motion';
import { Code2, Smartphone, Database, FileText, Settings, Zap } from 'lucide-react';

const Services = () => {
  const serviceCards = [
    {
      icon: Code2,
      title: 'Desarrollo de Sistemas',
      description: 'Sistemas empresariales personalizados para optimizar operaciones diarias.',
      color: 'from-blue-500 to-indigo-500'
    },
    {
      icon: Smartphone,
      title: 'Apps Móviles',
      description: 'Aplicaciones nativas e híbridas para iOS y Android, listas para el mercado.',
      color: 'from-green-500 to-emerald-500'
    },
    {
      icon: Database,
      title: 'APIs y Backends',
      description: 'Integraciones seguras y escalables para conectar todo tu ecosistema.',
      color: 'from-purple-500 to-pink-500'
    },
    {
      icon: FileText,
      title: 'Soluciones Contables',
      description: 'Herramientas inteligentes para gestión financiera y reportes automáticos.',
      color: 'from-orange-500 to-red-500'
    },
    {
      icon: Settings,
      title: 'Consultoría IT',
      description: 'Asesoría experta para transformar tu infraestructura tecnológica.',
      color: 'from-teal-500 to-cyan-500'
    },
    {
      icon: Zap,
      title: 'Automatización',
      description: 'Procesos eficientes con IA y scripts para ahorrar tiempo y recursos.',
      color: 'from-yellow-500 to-amber-500'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-blue-50">
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nuestros Servicios
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ofrecemos un rango completo de soluciones digitales adaptadas a tus necesidades específicas.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {serviceCards.map((card, index) => {
            const Icon = card.icon;
            return (
              <motion.div
                key={card.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 group"
                whileHover={{ y: -10 }}
              >
                <div className={`w-16 h-16 bg-gradient-to-br ${card.color} rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <Icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">{card.title}</h3>
                <p className="text-gray-600 leading-relaxed">{card.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;